(() => {
  const qs = (selector, scope = document) => scope.querySelector(selector);
  const qsa = (selector, scope = document) => Array.from(scope.querySelectorAll(selector));

  const initMdHeader = (scope = document) => {
    const header = qs("#mdHeader", scope) || qs(".mdHeader", scope);
    if (!header || header.dataset.mdHeaderReady === "true") return;

    header.dataset.mdHeaderReady = "true";

    const burger = qs(".mdBurger", header);
    const sectionRoot = header.closest(".shopify-section") || document;
    const drawer =
      qs(".mdDrawer", sectionRoot) ||
      qs(`[id^="mdDrawer-"]`, document);

    const SHOW_AT = 24;
    const pageType = document.body?.dataset?.page || "";
    const isHome = pageType === "home";
    const isInner = pageType === "inner";

    /* =========================================
       HEADER VISIBILITY
       ========================================= */
    const updateHeaderVisibility = () => {
      const y = window.scrollY || document.documentElement.scrollTop || 0;

      if (isHome) {
        header.classList.toggle("is-visible", y > SHOW_AT);
      } else if (isInner) {
        header.classList.add("is-visible");
      } else {
        header.classList.add("is-visible");
      }
    };

    window.addEventListener("scroll", updateHeaderVisibility, { passive: true });
    updateHeaderVisibility();

    /* =========================================
       DRAWER / PANELS
       ========================================= */
    if (!burger || !drawer) return;

    const screens = qsa("[data-drawer-screen]", drawer);
    const openScreenButtons = qsa("[data-open-screen]", drawer);
    const backButtons = qsa("[data-back-screen]", drawer);

    const showScreen = (name = "root") => {
      screens.forEach((screen) => {
        const isActive = screen.getAttribute("data-drawer-screen") === name;
        screen.classList.toggle("is-active", isActive);
      });
    };

    const setDrawer = (open) => {
      drawer.classList.toggle("is-open", open);
      drawer.setAttribute("aria-hidden", open ? "false" : "true");
      burger.setAttribute("aria-expanded", open ? "true" : "false");
      document.documentElement.style.overflow = open ? "hidden" : "";

      if (open) {
        showScreen("root");
      }
    };

    burger.addEventListener("click", () => {
      setDrawer(!drawer.classList.contains("is-open"));
    });

    drawer.addEventListener("click", (event) => {
      const closeTarget = event.target.closest("[data-close='1']");
      if (closeTarget) {
        setDrawer(false);
        return;
      }

      const link = event.target.closest(".mdDrawer__link[href]");
      if (link) {
        setDrawer(false);
      }
    });

    openScreenButtons.forEach((button) => {
      button.addEventListener("click", () => {
        const target = button.getAttribute("data-open-screen");
        if (target) showScreen(target);
      });
    });

    backButtons.forEach((button) => {
      button.addEventListener("click", () => showScreen("root"));
    });

    window.addEventListener("keydown", (event) => {
      if (event.key === "Escape" && drawer.classList.contains("is-open")) {
        setDrawer(false);
      }
    });

    window.addEventListener("resize", () => {
      if (window.innerWidth >= 990 && drawer.classList.contains("is-open")) {
        setDrawer(false);
      }
    });
  };

  const boot = () => {
    initMdHeader(document);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", (event) => {
    initMdHeader(event.target);
  });

  document.addEventListener("shopify:section:reorder", () => {
    initMdHeader(document);
  });
})();